import { Grid } from "@material-ui/core";
import React from "react";
import UnidadeFiltro from "./UnidadeFiltro";
import UnidadeTab from "./UnidadeTab";
import { UnidadePageProvider } from "./UnidadePageContext";


const UnidadePage: React.FC = () => {


  return (
    <UnidadePageProvider>
      <Grid container spacing={3}>
        <UnidadeFiltro />

        <UnidadeTab />
      </Grid>
    </UnidadePageProvider>
  );
};

export default UnidadePage;
